import GamePads from '@utils/gamePads'
import store from '@store'
import { setCurData, commitClearCurData } from './until/commit'
import {formatMS} from './until/formatTime'
export default class Therapy {
  constructor() {
    this._initState()
    this.init()
    this.gamepad = new GamePads()
    this.keyEvent()
    this.update()
  }

  init() {
    this.stage = new createjs.Stage('therapy-canvas')
    this.stage.enableMouseOver()
    window.gameWidth = this.stage.canvas.width
    window.gameHeight = this.stage.canvas.height
    this.lastFrame = 0
    this.currentTherapy = null
    if (this.currentTherapy) {
      this.stage.addChild(this.currentTherapy.view)
    }
    this.stopValue = false

    this.vergenceDemand = 0
    commitClearCurData()
  }

  _initState() {
    let _state = store.state.therapy

    this.State_Therapy = _state
    this.State_Result = _state.result
    this.State_Sight = _state.sight
    this.State_Vergence = _state.vergence
    this.State_Eyemovent = _state.eyemovement

    Object.defineProperties(this, {
      preRunningTime: {
        get: () => this.State_Result.runningTime,
        set: val => {
          this.State_Result.runningTime = val
          store.state.therapy.preRunningTime = val
        },
      },
      remainTime: {
        get: () => this.State_Therapy.curData['剩余时间'] || 0,
        set: (value) => {
          this.State_Therapy.curData['剩余时间'] = value
        }
      }
    })
  }


  update(timestamp) {
    if (this.stopValue) {
      return
    }
    let dt = timestamp - this.lastFrame
    this.lastFrame = timestamp
    if (dt && dt < 100) {
      if (this.currentTherapy && this.currentTherapy.update) {
        this.currentTherapy.update(dt)
        if (
          this.currentTherapy.target &&
          this.currentTherapy.target.vergenceDemand
        ) {
          this.vergenceDemand = this.currentTherapy.target.vergenceDemand
        }
      }
      this.stage.update()
    }
    this.updateGamepads()
    this.updateCommitRemainTime(dt)

    window.requestAnimationFrame(timestamp => {
      this.update(timestamp)
    })
  }
  updateCommitRemainTime(dt) {
    if (!this.currentTherapy || !this.currentTherapy.runningTime) {
      return
    }
    this.preRunningTime++
    let remainTime =
      this.currentTherapy.config.duration * 60 * 1000 -
      Math.floor(this.currentTherapy.runningTime) +
      1000
    this.remainTime = formatMS(remainTime)
    if (remainTime <= 1000) {
      this.therapyClose()
      return
    }
  }

  updateGamepads() {
    if (!this.gamepad) {
      this.gamepad = new GamePads()
    }
    this.gamepad.update()
    if (
      this.currentTherapy &&
      this.gamepad.justPressed('BACK')
    ) {
      this.therapyClose()
    }
  }

  stop() {
    this.stopValue = true
  }

  continue() {
    if (this.stopValue) {
      this.stopValue = false
      this.update()
    }
  }

  changeTherapy(CurTherapy, config, type) {
    this.beforeChange(config, type)
    let remainTime = config.duration
    if (remainTime) {
      setCurData({ 剩余时间: remainTime })
    }

    this.currentTherapy = new CurTherapy(this, this.config)
    window.currentTherapy = this.currentTherapy
    this._initDataPanel()
    this.stage.addChild(this.currentTherapy.view)
  }
  // 初始化 数据面板
  // 应该放到具体 训练实例 中进行初始化
  _initDataPanel() {
    let curKey = this.State_Therapy.curTherapy.name
    if (curKey === 'RoadRace') {
      let raceData = { 加速时间: 0 + '秒' }
      setCurData(raceData)
      return
    }
    let curArry = ['STE', 'AC', 'Saccadic', 'VisualMemory']
    let isCur = curArry.includes(curKey)
    if (isCur) {
      setCurData({
        正确次数: 0,
        错误次数: 0,
      })
    }
  }

  beforeChange(config, type) {
    if (window.gameAlready) {
      this.gameClose()
    }

    window.gameAlready = true
    window.gameWidth = this.stage.canvas.width
    window.gameHeight = this.stage.canvas.height
    this.config = JSON.parse(JSON.stringify(config))
    this.basicResult = {
      startTime: Date.now(),
      tName: type,
    }
    this.continue()
    this.keyEvent()

  }
  keyEvent() {
    $(document).bind('keyup', ev => {
      if (ev.keyCode === 8 || ev.keyCode === 13) {
        this.therapyClose()
      }
    })
  }
  gameClose() {
    this.stop()
    this.preRunningTime = 0
    if (this.currentTherapy && this.currentTherapy.runningTime) {
      store.commit('therapy/setTherapyResult', {
        runningTime: this.currentTherapy.runningTime,
      })
      this.currentTherapy.runningTime = 0
    }
    createjs.Sound.removeAllSounds()

    $(document).unbind()
    this.stage.removeAllEventListeners()
    this.stage.removeAllChildren()
    this.stage.update()
    if (this.currentTherapy && this.currentTherapy.clear) {
      this.currentTherapy.clear()
    }

    store.commit('therapy/updateStatus', 'ending')
    this.currentTherapy = null
    window.gameAlready = false
    window._THERAPY_STATE_ = 'ending'
  }

  therapyClose() {
    this.gameClose()
    store.commit('showTherapyOverMsgBox', true)
    // store.commit('therapy/updateStatus', 'ready')
  }
}

